import { render, staticRenderFns } from "./Cupcakes.vue?vue&type=template&id=5587461f&"
import script from "./Cupcakes.vue?vue&type=script&lang=js&"
export * from "./Cupcakes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports